import { render, staticRenderFns } from "./data-metering-data-link.vue?vue&type=template&id=ad2491b2&"
import script from "./data-metering-data-link.vue?vue&type=script&lang=js&"
export * from "./data-metering-data-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports